import AC from "./AC.json";
import CP from "./CP.json";
import EV from "./EV.json";
import HM from "./HM.json";
import LF from "./LF.json";
import MS from "./MS.json";
import defaultTemplate from "./default.json";

export default { AC, CP, EV, HM, LF, MS, defaultTemplate };
